var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { SidebarService } from '@ibe/services/ui';
import { Router } from '@angular/router';
var INDRAPaymentAlertComponent = /** @class */ (function (_super) {
    __extends(INDRAPaymentAlertComponent, _super);
    function INDRAPaymentAlertComponent(modalService, router, sidebarService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.router = router;
        _this.sidebarService = sidebarService;
        return _this;
    }
    INDRAPaymentAlertComponent.prototype.ngOnInit = function () {
        this.modalType = this.modalService.params[2];
    };
    INDRAPaymentAlertComponent.prototype.actionButton = function () {
        var pnr = this.modalService.params[0];
        var lastname = this.modalService.params[1];
        if (this.modalType === 'paymentAlert') {
            this.router.navigate(['/my-bookings/details', pnr, lastname]);
        }
        else if (this.modalType === 'bookingPaymentAlert') {
            this.router.navigate(['/my-bookings/view', pnr, lastname]);
        }
        else if (this.modalType === 'emailAlert') {
            this.sidebarService.openSidebar(['contacts', { pnr: pnr }]);
        }
        this.closeModal();
    };
    INDRAPaymentAlertComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    return INDRAPaymentAlertComponent;
}(AbstractModalContentComponent));
export { INDRAPaymentAlertComponent };
